module.exports = __webpack_public_path__ + "img/3.df612bb3.svg";